import React from 'react'
import { ICONS } from '@Const/common'
import { LegacyRecording } from '@Entities/matching/recording-group-details'

interface DspDataSectionProps {
    recordingData: LegacyRecording
    dspLink: string | undefined
}
const DspDataSection = (props: DspDataSectionProps) => {
    const { recordingData, dspLink } = props
    const { dsp, senderResourceId } = recordingData
    return (
        <>
            <div className="section-header">
                <img src={ICONS.recordingDSP} />
                <h5>DSP Data</h5>
            </div>
            <div className="details dsp-details">
                <div className="vertical-detail">
                    <p className="underline dsp-label">DSP Name</p>
                    <p className="semi-bold">{dsp[0].toUpperCase() || 'N/A'}</p>
                </div>
                <div className="vertical-detail">
                    <p className="underline dsp-label">DSP Identifier</p>
                    <p className="semi-bold">{senderResourceId || 'N/A'}</p>
                </div>
                <div className="vertical-detail">
                    <p className="underline dsp-label">DSP Audio Link</p>
                    {dspLink ? (
                        <a className="underline" target="_blank" href={dspLink} rel="noreferrer">
                            {dspLink}
                        </a>
                    ) : (
                        <p className="not-available">Not Available</p>
                    )}
                </div>
            </div>
        </>
    )
}
export default DspDataSection
